import React from 'react';
import Header from "../components/Header";
import SimpleHeader from "../components/SimpleHeader";
import Footer from "../components/Footer";
import graduateDatabase from "../database/graduates.json";
import Graduate from "../components/Graduate";
import PageTitle from "../components/PageTitle";

const Graduates = () => {
    return (
        <>
            <PageTitle title='Graduates' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"graduates"}
                    route={"graduates"}
                    url={"graduates"}
                />
                <div className='graduate-container max-w'>
                    {graduateDatabase.map((graduate, index) => (
                        <Graduate
                            key={index}
                            title={graduate.title ? graduate.title : null}
                            projectNr={graduate.projectNr ? graduate.projectNr : null}
                            facility={graduate.facility ? graduate.facility : null}
                            image={graduate.image ? graduate.image : null}
                        />
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Graduates;